import {
  CLEAR_CONTEXT,
  SET_GROUP_COMPANY_ID,
  SET_PROJECT_ID,
  SET_PROJECT,
  SET_HAS_MULTIPLE_GROUP_COMPANIES,
  START_PROCESSING,
  STOP_PROCESSING
} from "../constants/actionTypes";

const initialState = {
  hasMultipleGroupCompanies: false,
  groupCompanyId: null,
  projectId: null,
  project: null,
  processing: false
};

const context = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_CONTEXT:
      return initialState;
    case SET_HAS_MULTIPLE_GROUP_COMPANIES:
      return {
        ...state,
        hasMultipleGroupCompanies: action.hasMultipleGroupCompanies
      };
    case SET_GROUP_COMPANY_ID:
      return {
        ...state,
        groupCompanyId: action.groupCompanyId
      };
    case SET_PROJECT_ID:
      return {
        ...state,
        projectId: action.projectId
      };
    case SET_PROJECT:
      return {
        ...state,
        project: action.project
      };
    case START_PROCESSING:
      return {
        ...state,
        processing: true
      };
    case STOP_PROCESSING:
      return {
        ...state,
        processing: false
      };
    default:
      return state;
  }
};

export default context;
